// 差分(diff)ツールチップの「前日比」の文字列(#1487)。apex_chart_controller.js#setupDiffTooltips が使う。
//
// - 増減の向きは差分の値で決める: 正なら「↑」、負なら「↓」、0 なら矢印を付けず「±0」(率は出さない)
// - 率は小数 1 桁で出し、丸めて 0 になる小さな率は桁を増やす(最大 3 桁)。それでも 0 なら「0.001%未満」
//   (率はサーバーで小数 2 桁に丸めている。ApplicationController#generate_chart_data など)
// - 率がちょうど 0 / 欠損なら率を出さない。前日の値が 0 のとき(率を計算できない)もサーバーは 0 を入れるため
// - 率の符号は差分の向きに合わせて付ける。-0 や「-0.0%」は出さない
// - 差分が数値でない(null / 欠損)ときは null(前日比の行を出さない)

// 率の小数の桁。丸めて 0 になるうちは次の桁を試す
const PERCENTAGE_DECIMALS = Object.freeze([1, 2, 3])

const toFiniteNumber = (value) => {
  if (value === null || value === undefined || value === "") return null
  const number = typeof value === "number" ? value : Number(value)
  return Number.isFinite(number) ? number : null
}

// 率の絶対値の文字列(符号なし)。丸めて 0 になるうちは桁を増やす
export function formatDiffPercentageMagnitude(percentage) {
  const magnitude = Math.abs(percentage)
  for (const decimals of PERCENTAGE_DECIMALS) {
    const text = magnitude.toFixed(decimals)
    if (Number(text) !== 0) return `${text}%`
  }
  const smallest = (10 ** -PERCENTAGE_DECIMALS[PERCENTAGE_DECIMALS.length - 1]).toFixed(PERCENTAGE_DECIMALS[PERCENTAGE_DECIMALS.length - 1])
  return `${smallest}%未満`
}

// diff: 前日との差分、percentage: 前日比の率(%。0〜100 の値)、formatValue: 差分の絶対値の書式(系列が載る軸の書式)
// 戻り値: { direction: "up" | "down" | "flat", text } または null
export function buildDiffSummary({ diff, percentage, formatValue = (value) => String(value) } = {}) {
  const diffValue = toFiniteNumber(diff)
  if (diffValue === null) return null

  if (diffValue === 0) {
    return { direction: "flat", text: `±${formatValue(0)}` }
  }

  const direction = diffValue > 0 ? "up" : "down"
  const icon = direction === "up" ? "↑" : "↓"
  const sign = direction === "up" ? "+" : "-"
  const amount = formatValue(Math.abs(diffValue))

  const rate = toFiniteNumber(percentage)
  if (rate === null || rate === 0) return { direction, text: `${icon} ${amount}` }

  return { direction, text: `${icon} ${amount} (${sign}${formatDiffPercentageMagnitude(rate)})` }
}
